import React from "react";
import { Divider, Grid, Paper, Typography } from "@material-ui/core";
import { Spinner, Topbar } from "@components";
import { useGetTravelRequestQuery } from "@graphql";
import { TravelRequestForm } from "./TravelRequestForm";
import { BookingGroupCard } from "@bookings/BookingGroupCard/BookingGroupCard";
import { locale } from "@bonliva-crm/locale";

type Props = {
  bookingId?: string;
  bookingGroupId?: string;
  requestId?: string;
};

export function TravelRequestPage(props: Props) {
  const { requestId } = props;

  const { data, loading, error } = useGetTravelRequestQuery({
    variables: { requestId },
    skip: !requestId
  });

  if (loading) {
    return <Spinner fullHeight />;
  }

  if (error) {
    throw new Error(error.toString());
  }

  const bookingGroupId = props.bookingGroupId ?? data?.travelRequestById?.bookingGroup;

  const title = bookingGroupId
    ? locale.newTravelOrAccommodationRequest
    : locale.newTravelRequest;

  return (
    <Grid container spacing={2} style={{ padding: 16, marginTop: -16 }}>
      <Grid item xs={12}>
        <Topbar>
          <Typography variant="h6">{title}</Typography>
        </Topbar>

        <Divider style={{ margin: "8px -16px 0" }} />

        {bookingGroupId ? (
          <Grid item xs={12} style={{ marginTop: 16 }}>
            <BookingGroupCard bookingGroupId={bookingGroupId} />
          </Grid>
        ) : null}

        <Grid item xs={12} style={{ marginTop: 16 }}>
          <Paper style={{ padding: 16 }}>
            <TravelRequestForm
              bookingGroupId={bookingGroupId}
              initialData={data?.travelRequestById ?? null}
              readonly={!!requestId}
              isNew={!requestId}
            />
          </Paper>
        </Grid>
      </Grid>
    </Grid>
  );
}
